import { useState, useEffect } from "react";

export default function TechnicienForm({ onSubmit, technicien }) {

  const initialForm = {
    nom: "",
    email: "",
    mot_de_passe: "",
    role: "TECHNICIEN"
  };

  const [form, setForm] = useState(initialForm);

  // 🔄 Mode modification
  useEffect(() => {
    if (technicien) {
      setForm({
        ...technicien,
        mot_de_passe: "" // sécurité
      });
    } else {
      setForm(initialForm);
    }
  }, [technicien]);

  // ✍️ Change input
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  // 🚀 Submit
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);

    // ✅ vider formulaire seulement après ajout
    if (!technicien) {
      setForm(initialForm);
    }
  };

  return (
    <form className="client-form" onSubmit={handleSubmit}>
      
      <input
        name="nom"
        placeholder="Nom"
        value={form.nom}
        onChange={handleChange}
        required
      />

      <input
        name="email"
        placeholder="Email"
        value={form.email}
        onChange={handleChange}
        required
      />

      <input
        type="password"
        name="mot_de_passe"
        placeholder="Mot de passe"
        value={form.mot_de_passe}
        onChange={handleChange}
        required={!technicien}
      />

      <select
        name="role"
        value={form.role}
        onChange={handleChange}
      >
        <option value="ADMIN">ADMIN</option>
        <option value="TECHNICIEN">TECHNICIEN</option>
      </select>

      <button>
        {technicien ? "Mettre à jour" : "Enregistrer"}
      </button>
    </form>
  );
}
